import gsap from 'gsap'

import {
  getScrollTriggerOptions,
  linesRevealAnimation,
  SharedAnimation
} from './shared'
import { Animation } from '@/types'

export const heroRevealAnimation = ({
  node,
  mobile,
  context,
  reverse
}: Animation) => {
  const selector = context?.selector || gsap.utils.selector(node)

  const mask = selector('[data-motion-mask]')[0]
  mask && gsap.to(mask, { opacity: 0, duration: 0.5, ease: 'power2.inOut' })

  if (mobile) return

  const title = selector('[data-motion-title]')[0]
  const media = selector('[data-motion-media]')[0]
  const overline = selector('[data-motion-overline]')[0]

  const timeline = gsap.timeline({
    ...getScrollTriggerOptions(node, reverse),
    onComplete: () => mask?.remove()
  })

  if (media) {
    timeline.add(
      gsap
        .timeline()
        .fromTo(
          media,
          { opacity: 0, scale: 1.1 },
          { opacity: 1, scale: 1, duration: 2, ease: 'power1.out' }
        ),
      '<'
    )
  }

  let overlineAnimation: SharedAnimation
  if (overline) {
    overlineAnimation = linesRevealAnimation(overline, reverse)
    timeline.add(overlineAnimation.timeline, '<+0.2')
  }

  let titleAnimation: SharedAnimation
  if (title) {
    titleAnimation = linesRevealAnimation(title, reverse)
    timeline.add(titleAnimation.timeline, '<+0.2')
  }

  return () => {
    timeline.kill()

    titleAnimation?.revert()
    overlineAnimation?.revert()
  }
}
